import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ResultsDatabaseFactory {

  public static readonly DISPLAYED_COLUMNS: string[] = [
    'checkBox',
    'quizName',
    'firstname',
    'lastname',
    'email',
    'score',
    'endDate',
    'time',
    'delete'
  ];
}
